"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const string_utils_1 = require("@/common/string_utils");
function default_1(confirm) {
    if (window.isNativeApp) {
        window.location.href = '/notification/setting';
    }
    else {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('폰디앱에서만 지원하는 알림 서비스예요!'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('앱을 다운로드 해주세요')}:)`] })),
            confirmationText: i18next_1.default.t('앱 다운받기'),
        })
            .then(() => (window.location.href = string_utils_1.storeUrl))
            .catch(() => { });
    }
}
exports.default = default_1;
